export enum StoryTheme {
  BLACK,
  DARKBLUE,
  DARKGREEN,
  GREY,
  LIGHTBLUE,
  LIGHTGREEN,
  PETROL,
  RED,
  WHITE,
  YELLOW
}
